import { entityRegexStrategy } from '../commons';
export var productStrategy = entityRegexStrategy('PRODUCT_MENTION', /\$[a-zA-Z](\w*\s?){0,5}/g);